import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { without } from 'lodash';
import { removeFromArray } from '../../utils/immutable.js';
import { letters } from '../../utils/constants';
import './styles.styl';
import DragSource from './DragSource';
import DropTarget from './DropTarget';

class DragAndDrop extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visibleDropMenu: '',
      undroppedItems: []
    };

    props.setPartialCreditValidator(this.partialCreditValidator);
    props.setReviewSheet(this.renderReviewChunk);
  }

  UNSAFE_componentWillMount() {
    this.handleProps(this.props);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    this.handleProps(newProps);
  }

  handleProps(props) {
    if (!props.input) {
      // populate redux with dropZones object for input
      const blankInput = {};
      props.data.dropZones.forEach(dropZoneName => {
        blankInput[dropZoneName] = [];
      });
      props.onInput(blankInput);

      return; // since we have dispatched input, we can expect this function to be called again shortly
    }

    const droppedItems = [];
    Object.keys(props.input).forEach(dropZone => {
      props.input[dropZone].forEach(dragOption => {
        droppedItems.push(dragOption);
      });
    });
    const undroppedItems = without(props.data.dragOptions, ...droppedItems);

    this.props.setSubmitStatus(undroppedItems.length === 0);

    this.setState({
      undroppedItems: undroppedItems
    });
  }

  handleDrop = (dropped, option) => {
    const { input } = this.props;

    let newInput = input;

    this.props.data.dropZones.forEach(dropZone => {
      if (dropZone === option && !input[dropZone].includes(dropped)) {
        // if the targeted dropZone is this drop zone, and the option is not present, add the option
        newInput[dropZone].push(dropped);
      } else if (input[dropZone].includes(dropped) && dropZone !== option) {
        // if the option is present and the targeted dropZone is not this drop zone, remove the option
        newInput[dropZone] = removeFromArray(input[dropZone], dropped);
      }
    });

    // Ensure the drag item's popup is closed, if one was open
    this.setState({
      visibleDropMenu: ''
    });

    this.props.onInput(newInput);
  };

  handleKeyboardDrag = item => {
    this.setState(() => {
      return {
        visibleDropMenu: this.state.visibleDropMenu !== item ? item : ''
      };
    });
  };

  partialCreditValidator = (input, correctInput) => {
    let wrongPlacements = 0;

    Object.keys(correctInput).forEach(category => {
      correctInput[category].forEach(value => {
        if (!input[category].includes(value)) {
          wrongPlacements++;
        }
      });
    });

    return wrongPlacements < 2;
  };

  renderReviewChunk = () => {
    const { data, correctInput, question } = this.props;
    let correctAnswers = {};

    Object.keys(correctInput).map(dropZone => {
      data.dragOptions.forEach((option, index) => {
        if (correctInput[dropZone].includes(option)) {
          if (correctAnswers[dropZone] === undefined) {
            correctAnswers[dropZone] = [letters[index]];
          } else {
            correctAnswers[dropZone].push(letters[index]);
          }
        }
        return correctAnswers;
      });
      if (correctAnswers[dropZone].length > 1) {
        correctAnswers[dropZone].splice(
          correctAnswers[dropZone].length - 1,
          0,
          'and'
        );
        return (correctAnswers[dropZone] = correctAnswers[dropZone].join(' '));
      } else {
        return (correctAnswers[dropZone] = correctAnswers[dropZone][0]);
      }
    });

    return (
      <div>
        <p className="review-question">{question}</p>
        {data.dragOptions.map((dragOption, index) => {
          return (
            <p key={index} className="review-option">{`${
              letters[index]
            }. ${dragOption}`}</p>
          );
        })}
        <p className="review-correct">Correct Answers:</p>
        {Object.keys(correctInput).map((category, index) => {
          return (
            <p className="review-correct" key={index}>
              {category}: {correctAnswers[category]}
            </p>
          );
        })}
      </div>
    );
  };

  determineCorrectInput = dropZone => {
    if (this.props.correctInput) {
      return this.props.correctInput[dropZone];
    }
  };

  render() {
    const {
      validationResult,
      horizontal,
      input,
      isFinalAttempt,
      question
    } = this.props;
    const { dropZones, dropZoneMessage } = this.props.data;
    const { visibleDropMenu, undroppedItems } = this.state;
    const hasValidated = validationResult !== null;

    return (
      <div>
        {question && <p className="intro__lead">{question}</p>}
        <div
          className={classNames('drop-target-container', {
            'drop-target-container--horizontal': horizontal
          })}
        >
          {Object.keys(input ? input : []).map(dropZone => {
            return (
              <DropTarget
                key={dropZone}
                name={dropZone}
                onDrop={(dropped, dropZone) =>
                  this.handleDrop(dropped.item, dropZone)
                }
                droppedItems={input ? input[dropZone] : []}
                dropZoneMessage={dropZoneMessage}
                hasValidated={hasValidated}
                correctInput={this.determineCorrectInput(dropZone)}
                keyboardDND={this.handleKeyboardDrag}
                dropZones={dropZones}
                handleDrop={this.handleDrop}
                visibleDropMenu={visibleDropMenu}
                isFinalAttempt={isFinalAttempt}
              />
            );
          })}
        </div>
        <div className="drag-item-container">
          {undroppedItems.map(item => {
            return (
              <DragSource
                key={item}
                item={item}
                keyboardDND={this.handleKeyboardDrag}
                dropZones={dropZones}
                handleDrop={this.handleDrop}
                visibleDropMenu={visibleDropMenu}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

DragAndDrop.propTypes = {
  data: PropTypes.object.isRequired,
  setSubmitStatus: PropTypes.func.isRequired,
  onInput: PropTypes.func.isRequired,
  validationResult: PropTypes.bool,
  correctInput: PropTypes.object,
  horizontal: PropTypes.bool
};

export default DragAndDrop;



// WEBPACK FOOTER //
// ../core/src/components/DragAndDrop/DragAndDrop.js